import { Tag } from 'antd';
import './EnvironmentBadge.css';

/**
 * Environment Badge Component
 *
 * Displays environment name (non-prod only), version, and build timestamp in bottom-right corner.
 * - Production: Shows version only
 * - Non-production: Shows environment name, version, and optional build date
 * Hidden on mobile devices.
 *
 * Environment variables:
 * - REACT_APP_ENV: Environment name (development, staging, production)
 * - REACT_APP_VERSION: Version string (injected by CI/CD or .env)
 * - REACT_APP_BUILD_DATE: Build timestamp (optional, injected by CI/CD)
 */
const EnvironmentBadge = () => {
  const env = process.env.REACT_APP_ENV || 'production';
  const version = process.env.REACT_APP_VERSION || 'dev';
  const buildDate = process.env.REACT_APP_BUILD_DATE;
  const isProduction = env === 'production';

  return (
    <div className="environment-badge">
      {!isProduction && <Tag color="orange">{env.toUpperCase()}</Tag>}
      <Tag color="blue">{version}</Tag>
      {!isProduction && buildDate && <Tag color="green">{new Date(buildDate).toLocaleString()}</Tag>}
    </div>
  );
};

export default EnvironmentBadge;
